/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import BaseClass from './BaseClass'

/**
 * Created by Michal Rohac (H172336) on 3/27/2018.
 */
export default class NavigationItem extends BaseClass {
    constructor() {
        super()
        const privateFields = {
            name: '',
            icon: '',
            onClick: undefined,
            disabled: false,
        }
        BaseClass.privateField(this, 'name', privateFields, BaseClass.FIELD_TYPE.String)
        BaseClass.privateField(this, 'icon', privateFields, BaseClass.FIELD_TYPE.String)
        BaseClass.privateField(this, 'onClick', privateFields, BaseClass.FIELD_TYPE.Function)
        BaseClass.privateField(this, 'DISABLED', privateFields, BaseClass.FIELD_TYPE.Boolean)
    }
}